var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-health-detail"},[(_vm.healthDetail)?_c('BoardDetail',{attrs:{"board-id":_vm.id,"board":_vm.healthDetail,"list-path":"/information/health"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }